import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import moment from 'moment';
import ReactPaginate from 'react-paginate';
import { Grid, _ } from 'gridjs-react';
import { Card, CardBody, CardFooter, CardHeader, Col, Row } from 'reactstrap';
import { PreviewCardHeader, TablePagination } from '../../../../../../Common';
import { Constant } from '../../../../../../Helpers/constant';
import { PermissionConstants } from '../../../../../../Helpers/Constants/permissions';
import Countdown from 'react-countdown';
import { formattedWithComma, hasPermission, isDatePassed } from '../../../../../../Helpers/Helpers';

const Table = props => {
  const [data, setData] = useState([]);

  const [allData, setAllData] = useState([]);
  const [bookingData, setBookingData] = useState([]);
  const [selectedBookings, setSelectedBookings] = useState([]);
  const [serialColumnNumber, setSerialColumnNumber] = useState(1);
  const [isBulkActionShow, setIsBulkActionShow] = useState(false);
  const [currentFilterBookingStatus, setCurrentFilterBookingStatus] = useState(0);
  const [currentFilteredBookingTitle, setCurrentFilterBookingTitle] = useState('Bookings');

  const { binList, binListLoading } = useSelector(state => ({
    binList: state.BinsList.data,
    binListLoading: state.BinsList.loading,
  }));

  useEffect(() => {
    getBookingStatusTitleHandler(parseInt(props?.appliedFilters?.status));

    if (props?.data?.length > 0) {
      setAllData(props?.data);
      setBookingData(
        props?.data?.map(booking => {
          return { ...booking, checkboxValue: false };
        }),
      );
      setSelectedBookings([]);
      setIsBulkActionShow(false);
      getBookingStatusTitleHandler(parseInt(props?.appliedFilters?.status));
      setCurrentFilterBookingStatus(parseInt(props?.appliedFilters?.status));
    } else {
      setBookingData([]);
      setSelectedBookings([]);
      setCurrentFilterBookingStatus(0);
      setIsBulkActionShow(false);
    }
  }, [props?.data]);

  useEffect(() => {
    if (bookingData?.length > 0) {
      setAllData();
      setData(
        bookingData?.map((data, index) => {
          const status = Constant?.BOOKING_STATUSES?.filter(statusObj => statusObj.objectId === data?.bookingStatusCode)[0]?.name;
          return [
            // false,
            `${props.pageNumber * Constant.TABLE_PAGE_SIZE + (index + 1)}.`,
            data || `NA`,
            data?.user?.name || `NA`,
            data?.user?.mobile || `NA`,
            data?.user?.email || `NA`,

            data?.dateOfPlay ? moment(new Date(`${data?.dateOfPlay}`)).format('DD-MM-YYYY') : 'NA',
            data?.timeOfPlay ? moment(`${data?.timeOfPlay}`, 'HH:mm').format('h:mm A') : `NA`,

            data?.facility?.name || `NA`,
            data?.category?.name || `NA`,

            data?.cardDetails?.firstSix || `NA`,
            data?.cardDetails?.lastFour || `NA`,

            data?.updatedAt ? moment(new Date(`${data?.updatedAt}`)).format('DD-MM-YYYY, h:mm A') : 'NA',
            data?.bookingStatusCode ? status : 'NA',
            data,
          ];
        }),
      );

      setTimeout(() => {
        colorizeSlaBreached();
      }, [100]);
    } else {
      setData([]);
    }
  }, [bookingData, binList]);

  setTimeout(() => {
    colorizeSlaBreached();
  }, [100]);

  /* ---------------------------- COLORIZE SLA BREACH ---------------------------- */
  function colorizeSlaBreached() {
    if (props?.data?.length > 0) {
      const slaBreachedTableIndexes = props?.data
        ?.map((bookingData, index) => {
          if (bookingData?.slaDetails?.slaBreached) {
            return index;
          }
        })
        .filter(data => data !== undefined);

      Array.from(document.querySelectorAll('.gridjs-tr')).map((row, index) => {
        if (slaBreachedTableIndexes?.includes(index - 1)) {
          row.style.backgroundColor = `#ec7b65`;
          row.style.color = `#fff`;
        }
      });
    } else {
      Array.from(document.querySelectorAll('.gridjs-tr')).map((row, index) => {
        row.style.backgroundColor = `#fff`;
        row.style.color = `black`;
      });
    }
  }

  /* ---------------------------- BOOKING TABLE TITLE HANDLER ---------------------------- */
  const getBookingStatusTitleHandler = bookingsStatusCode => {
    let bookingsTitle = 'Bookings';

    if (bookingsStatusCode !== 0) {
      Constant?.BOOKING_STATUSES?.forEach(bookingStatus => {
        if (bookingsStatusCode === bookingStatus?.objectId) {
          bookingsTitle = `${bookingStatus?.name === 'Short Notice Cancelled By Thriwe' ? 'No Show' : `${bookingStatus?.name} Bookings`}`;
        }
      });
    }
    setCurrentFilterBookingTitle(bookingsTitle);
  };

  /* ---------------------------- ACTION HANDLER ---------------------------- */
  const actionBtnHandler = (flag, data) => {
    if (flag === `EDIT`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `VIEW`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `PROCESS`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `CONFIRM`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `CANCEL`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `UPDATE`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `RESEND_EMAIL`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    } else if (flag === `CONFIRM_WITH_DATA`) {
      props.actionHandler({
        bookingDetails: data,
        actionType: flag,
      });
    }
  };

  return (
    <>
      <Row>
        <Col xxl={12}>
          <Card>
            <CardHeader className="d-flex">
              <h4 className="card-title mb-0 flex-grow-1">{currentFilteredBookingTitle}</h4>

              {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.DOWNLOAD_ACCESS) && props?.data?.length > 0 && (
                <span className="btn btn-success mb-1" onClick={props?.dumpDownload}>
                  <i className="ri-download-line me-1 text-white fs-14 align-middle"></i>Download dump
                </span>
              )}
            </CardHeader>

            {/* ------------------------ TABLE DETAILS ------------------------ */}
            {props?.data?.length > 0 && (
              <CardBody>
                <div id="table-gridjs">
                  <Grid
                    data={data}
                    columns={[
                      {
                        name: 'S.No.',
                        width: '60px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Booking ID',
                        width: '150px',
                        formatter: (cell, row) =>
                          _(
                            <span
                              className="fw-semibold"
                              style={{
                                cursor: 'pointer',
                                textDecoration: 'underline',
                                color: '#3577f1',
                              }}
                              onClick={() => actionBtnHandler(`VIEW`, cell)}
                            >
                              {cell?.bookingId}
                            </span>,
                          ),
                      },

                      {
                        name: 'Full Name',
                        width: '160px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Mobile No.',
                        width: '140px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Email',
                        width: '220px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Date Of Visit',
                        width: '130px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Time of Visit',
                        width: '120px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Outlet',
                        width: '200px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Category',
                        width: '200px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Bin number',
                        width: '140px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Last four digits',
                        width: '140px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Updated At',
                        width: '180px',
                        formatter: cell => _(<span className="">{cell}</span>),
                      },

                      {
                        name: 'Status',
                        width: '140px',
                        formatter: cell =>
                          _(
                            <span
                              className={`booking_status break-word badge bg-${
                                Constant.BOOKING_STATUSES.filter(status => status?.name === cell)[0]?.bgColor
                              }`}
                            >
                              {cell}
                            </span>,
                          ),
                      },

                      {
                        name: 'Actions',
                        width: '120px',
                        formatter: (cell, row) =>
                          _(
                            <div className="d-flex justify-content-center flex-column">
                              {
                                // DEFAULT
                              }
                              {cell?.workflow === Constant.WORKFLOWS[0] && (
                                <>
                                  {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLUB_BOOKING_UPDATE) &&
                                    row.cells[row?.cells?.length - 2].data === 'Pending' && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-primary mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`PROCESS`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Process
                                        </button>

                                        <button
                                          className="btn btn-sm btn-primary mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`RESEND_EMAIL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Resend Email
                                        </button>

                                        <button
                                          className="btn btn-sm btn-danger mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`CANCEL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}

                                  {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLUB_BOOKING_UPDATE) &&
                                    row.cells[row?.cells?.length - 2].data === 'Processed' && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-primary mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`CONFIRM`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Confirm
                                        </button>

                                        <button
                                          className="btn btn-sm btn-danger mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`CANCEL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}

                                  {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLUB_BOOKING_UPDATE) &&
                                    row.cells[row?.cells?.length - 2].data === 'Confirmed' && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-primary mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`RESEND_EMAIL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Resend Email
                                        </button>

                                        <button
                                          className="btn btn-sm btn-danger mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`CANCEL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Cancel
                                        </button>
                                      </>
                                    )}

                                  {hasPermission(PermissionConstants?.ALL_PERMISSIONS?.CLUB_BOOKING_UPDATE) &&
                                    row.cells[row?.cells?.length - 2].data === 'Cancel By Thriwe' && (
                                      <>
                                        <button
                                          className="btn btn-sm btn-primary mb-1"
                                          onClick={() => {
                                            actionBtnHandler(`RESEND_EMAIL`, cell);
                                          }}
                                          disabled={isDatePassed(cell?.bookingDateTime)}
                                        >
                                          Resend Email
                                        </button>
                                      </>
                                    )}
                                </>
                              )}
                            </div>,
                          ),
                      },
                    ]}
                    search={false}
                    sort={false}
                    fixedHeader={true}
                    // height="400px"
                    pagination={{ enabled: false, limit: 5 }}
                  />
                </div>
                {props.children}
              </CardBody>
            )}

            {props?.data?.length === 0 && (
              <CardBody>
                <h5 className="text-center">Record not found!</h5>
              </CardBody>
            )}

            {props?.data?.length > 0 && (
              <CardFooter>
                <Row className="custom_pagination">
                  <Col md={12} className="d-flex justify-content-between align-items-center">
                    <div>
                      Showing <b>{formattedWithComma(props?.pageNumber * Constant?.TABLE_PAGE_SIZE + 1)}</b> to&nbsp;
                      <b>{formattedWithComma(props?.pageNumber * Constant?.TABLE_PAGE_SIZE + props?.data?.length)}</b> of{' '}
                      <b>{formattedWithComma(props?.totalData)}</b> records
                    </div>
                    <div className="d-flex justify-content-end">
                      <TablePagination totalData={props?.totalData} currentPage={props?.pageNumber} onPageChangeHandler={props?.pageHandler} />
                    </div>
                  </Col>
                </Row>
              </CardFooter>
            )}
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default React.memo(Table);
